import type CalendarState from "../calendarState";
import {Action} from "../../../action/action";
import { Partner } from "@raskrask-dk/raskrask-utils";


export const SET_PARTNER = "SET_PARTNER";

/**
 * This action is setting the partner on the calendar state.
 * Doing this action will move the machine to the CalendarState.
 */
export class SetPartner extends Action<"SET_PARTNER", Partner> {
  readonly type = "SET_PARTNER";
  protected state: CalendarState;

  constructor(state: CalendarState, data?: Partner) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if (!this.data) return true;
    if (!this.isDoable()) return false;
    const {serviceType, date} = this.state.getData();
    if (!serviceType) return false;
    if (!date) return true;
    const partners = serviceType.getPartnersBy();
    const partner = partners.find((p) => p.id === this.data.id);
    if (!partner) return false;
    const timeslots = partner.schedule.timeslotsByDay(date, serviceType.duration);
    const hasTimeslots = timeslots.length > 0;
    return hasTimeslots;
  }

  /**
   * This function is currently missing the condition checking the data
   * from the api.
   * @returns whether the request button should be an option
   */
  public isDoable(): boolean {
    const {goal, serviceType} = this.state.getData();
    const isRequiredValuesSet = this.allHasValues(goal, serviceType);
    return isRequiredValuesSet;
  }
}
